// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styling is intentionally small; the shared AuthShell owns
   the visual system for all authentication screens. */
`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;sDACsD","sourcesContent":["/* Page-specific styling is intentionally small; the shared AuthShell owns\n   the visual system for all authentication screens. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
